// extracted by mini-css-extract-plugin
export default {"textContainer":"TextHeader_textContainer__yi9vS","text":"TextHeader_text__zK1om"};